import { render, staticRenderFns } from "./segmentList.vue?vue&type=template&id=efb0cc86"
import script from "./segmentList.vue?vue&type=script&lang=js"
export * from "./segmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports